import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { PublicHeader } from "@/components/PublicHeader";
import { SiteFooter } from "@/components/SiteFooter";

export const ResourcesLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-[#F8F9FA]">
    <PublicHeader />
    <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-8 py-10 sm:py-14">{children}</main>
    <SiteFooter />
  </div>
);

export const ResourcesGate = ({ children, next = "/resources" }) => {
  const { auth } = useApp();
  if (auth === null) return <ResourcesLayout><p className="text-gray-500">Loading…</p></ResourcesLayout>;
  if (!auth) return <ResourcesLayout>
    <div className="max-w-lg bg-white border border-[#E5E7EB] rounded-lg p-8" data-testid="resources-signin-required">
      <div className="w-11 h-11 rounded-full bg-[#FFF0F0] text-[#E60000] grid place-items-center"><Lock className="w-5 h-5" /></div>
      <h1 className="font-heading text-2xl font-extrabold mt-4">Sign in to view Resources</h1>
      <p className="text-sm text-gray-600 mt-2">GAMLS Reports and the photo Gallery are available to signed-in members and staff.</p>
      <Link to={`/login?next=${encodeURIComponent(next)}`} className="mt-6 h-10 px-5 inline-flex items-center rounded-md bg-[#E60000] hover:bg-[#CC0000] text-white text-sm font-semibold transition-colors" data-testid="resources-signin-button">Login</Link>
    </div>
  </ResourcesLayout>;
  return <ResourcesLayout>{children}</ResourcesLayout>;
};
